import React, { Component } from 'react'
import { FormControl, Select, MenuItem } from '@mui/material'
import { FormInputLabel } from '@/shared/ui/input'

class DisplayItemDossierDataSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dossier_data:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.dossier_data
                    ? this.props.item.settings.dossier_data
                    : null,
            display_name_style:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.display_name_style
                    ? this.props.item.settings.display_name_style
                    : null,
        }
    }

    render() {
        const kedo = this.props.kedo

        let defDossierId = this.state.block_data
            ? this.state.block_data.def_dossier_id
            : null

        return (
            <div>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{kedo.t('Dossier data')}</FormInputLabel>
                    <Select
                        size="small"
                        name={'dossier_data'}
                        onChange={(e) => {
                            this.setState({ dossier_data: e.target.value })
                            this.props.onChange('dossier_data', e.target.value)
                        }}
                        value={this.state.dossier_data || ''}
                        displayEmpty
                        disabled={this.props.disabled}
                    >
                        <MenuItem value={''}>
                            {kedo.t('Choose an option')}
                        </MenuItem>
                        <MenuItem value={'created_by'}>
                            {kedo.t('Created by')}
                        </MenuItem>
                        <MenuItem value={'modified_by'}>
                            {kedo.t('Modified by')}
                        </MenuItem>
                        <MenuItem value={'created_at'}>
                            {kedo.t('Created at')}
                        </MenuItem>
                        <MenuItem value={'modified_at'}>
                            {kedo.t('Modified at')}
                        </MenuItem>
                        <MenuItem value={'dossier_id'}>
                            {kedo.t('Dossier id')}
                        </MenuItem>
                    </Select>
                    <br />
                    <FormInputLabel>
                        {kedo.t('Display name style')}
                    </FormInputLabel>
                    <Select
                        size="small"
                        displayEmpty
                        id={'display_name_style'}
                        value={this.state.display_name_style || ''}
                        disabled={this.props.disabled}
                        onChange={(e) => {
                            this.setState({
                                display_name_style: e.target.value,
                            })
                            this.props.onChange(
                                'display_name_style',
                                e.target.value
                            )
                        }}
                    >
                        <MenuItem value="default">Default</MenuItem>
                        <MenuItem value="avatar">Avatar</MenuItem>
                        <MenuItem value="both">Both</MenuItem>
                    </Select>
                </FormControl>
            </div>
        )
    }
}

export default DisplayItemDossierDataSettings
